<!-- /////////////////////////////////////////////////////////////////////////// TEMPLATE -->

<template>
    <div class="flex justify-center align-middle">
        <!-- Discount Information (if any) -->
        <tippy v-can="'price:view'" class="mr-3">
            <div
                v-if="row.special_price !== null && !orderIsMoreExpensiveThanCatalogPrice"
                :class="{ 'blur': !isPriceVisible }"
            >
                <mdi-icon icon="mdiSale" class="w-5 h-5 text-primary-300" />
            </div>

            <template #content>
                <div class="text-gray-500" :class="{ 'blur': !isPriceVisible }">
                    <span class="text-primary-500">{{ $t('order_table.base_price_colon') }}</span>
                    {{ row.currency_code }}&nbsp;{{
                        $f(row.catalog_total, "numberFormat:2,'")
                    }}
                    <br>

                    <span class="text-primary-500">{{ $t('order_table.discount_colon') }}</span>
                    {{ discount }}
                </div>
            </template>
        </tippy>

        <!-- Price -->
        <span class="text-sm text-gray-500" :class="{ 'blur': !isPriceVisible }">
            {{ price }}
        </span>
    </div>
</template>

<!-- /////////////////////////////////////////////////////////////////////////// SCRIPT -->

<script>
import Numbers from '@/utils/Numbers';

export default
{
    name: 'OrderPriceCell',

    props:
    {
        row:
        {
            type:     Object,
            required: true,
        },

        rows:
        {
            type:     Array,
            required: true,
        },

        column:
        {
            type:     Object,
            required: true,
        },

        updating:
        {
            type:    Boolean,
            default: false,
        },
    },


    computed:
    {
        price()
        {
            if(!this.$store.getters['account/can']('price:view'))
            {
                return '-';
            }

            const price = this.row.total;
            return this.$f(price, "numberFormat:2,'");
        },

        subtotal()
        {
            const order = this.row;
            return order.supplements.reduce(
                (acc, s) => acc + s.price * s.quantity,
                order.price
            );
        },

        discount()
        {
            const discount = (1 - (this.row.total / this.row.catalog_total)) || 0;

            return Numbers.round(discount * 100, 1) + '%';
        },

        isPriceVisible()
        {
            return this.$store.state.pricesVisible;
        },

        orderIsMoreExpensiveThanCatalogPrice()
        {
            const order = this.row;
            if(order.special_price === null)
            {
                return false;
            }

            return order.special_price > this.subtotal;
        },
    },
};
</script>

<!-- /////////////////////////////////////////////////////////////////////////// STYLE -->

<style lang="css" scoped>
</style>
